import type { FaqItem } from "@/types/content";

export const faqList: FaqItem[] = [
  {
    q: "黑料八卦主要收录哪些内容？",
    a: "我们专注综艺、影视、节目与剧组的幕后信息，包括拍摄现场的调度见闻、剪辑台被舍弃的镜头、服化道与场务的日常协作等。核心是把「镜头之外的剧情」补全，而不是复述正片内容。",
  },
  {
    q: "网站上的幕后内容是真实发生的吗？",
    a: "站内稿件均基于公开的制作访谈、主创分享与行业从业者的公开讲述整理而成，涉及具体作品时会标注可核实的来源方向。我们不对未公开的私人事务进行揣测，也不传播未经证实的个人信息。",
  },
  {
    q: "为什么有的节目只写了拍摄现场，没有写后期？",
    a: "每一部作品的幕后素材公开程度不同。部分项目出于保密约定只开放了拍摄阶段的信息，我们会如实呈现已公开的部分，并在文末说明尚未公开的环节。",
  },
  {
    q: "可以在黑料八卦投稿自己经历的剧组故事吗？",
    a: "非常欢迎。你可以通过「关于我们」页面底部的联系表单提交选题线索，写清楚作品类型、大致阶段与你愿意公开的信息范围即可。发布前我们会与你逐条确认可公开的细节。",
  },
  {
    q: "内容多久更新一次？",
    a: "幕后内容依赖素材的公开节奏，因此没有固定频率。综艺与影视热播期更新会密集一些，淡季则侧重行业观察与幕后方法论的深度稿件，平均每周保持三到五篇。",
  },
  {
    q: "如何快速找到我感兴趣的幕后类型？",
    a: "首页顶部的分类导航提供了综艺幕后、影视探班、剧组江湖、幕后故事、拍摄现场与剪辑台六个方向。你也可以直接进入分类页，按最新或按热度切换排序。",
  },
];